<template>
	<div>
		<app-head :title="`INVOICE ` + invoice.id" />

		<div class="mt-8 mb-4 text-center">
			<a :href="route('public.invoices.download', invoice)"
				target="_blank"
				class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary">
				Download PDF
			</a>
		</div>

		<invoice-template :invoice="invoice" />
	</div>
</template>
<script>
import AppHead from '@/Shared/AppHead'
import Guest from '@/Layouts/Guest'
import InvoiceTemplate from '@/Pages/Backend/Invoices/Invoice'

export default {
	components: { AppHead, InvoiceTemplate },
	layout: Guest,
	props: {
		invoice: {
			type: Object,
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
